<script setup lang="ts">
import { UiSkeleton, UiStepLayout } from "@/shared/ui";

/** Количество селектов на первом экране, чей каркас повторяет скелетон */
const FIELDS_COUNT = 5;
</script>

<!-- Repeats the layout of the first screen while the widget data is loading (InitWidgetLoader in v2) -->
<template>
    <UiStepLayout :with-footer="false" role="status" aria-busy="true">
        <template #header>
            <div class="header">
                <UiSkeleton width="354px" height="20px" />
                <UiSkeleton width="306px" height="20px" />
            </div>
        </template>

        <div class="form">
            <div v-for="field in FIELDS_COUNT" :key="field" class="field">
                <UiSkeleton width="120px" height="14px" />
                <UiSkeleton width="100%" height="40px" />
            </div>
        </div>

        <div class="button">
            <UiSkeleton width="129px" height="40px" />
        </div>

        <div class="footer">
            <UiSkeleton width="400px" height="16px" />
            <UiSkeleton width="266px" height="24px" class="footer__chat" />
        </div>
    </UiStepLayout>
</template>

<style scoped>
.header {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 12px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.button {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
}

.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.footer__chat {
    margin-top: 4px;
    margin-bottom: 8px;
}
</style>
